import React from "react";
import { Link } from "react-router-dom";

export default function AppFooterFooter() {
  return (
    <footer className="bg-brand-navy text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div className="flex flex-col items-start">
          <Link to="/" onClick={() => window.scrollTo(0, 0)}>
            <img src="/images/Logo-v2.svg" alt="EAP Consulting" className="w-48 mb-4 brightness-0 invert" />

            <p className="text-sm tracking-wide opacity-90">
              RECONOCE. RESPETA. SANA. POTENCIA.
            </p>
          </Link>
        </div>
        <div>
          <h3 className="text-xl font-semibold mb-4">Contáctenos</h3>
          <div className="flex items-center gap-4 mb-3">
            <a 
              href="https://www.facebook.com/profile.php?id=61584020998454&mibextid=rS40aB7S9Ucbxw6v" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-80 transition"
            >
              <svg width="28" height="28" fill="white" viewBox="0 0 24 24">
                <path d="M22 12.07C22 6.48 17.52 2.07 12 2.07S2 6.48 2 12.07c0 4.99 3.66 9.12 8.44 9.88v-6.99h-2.54v-2.89h2.54V9.41c0-2.51 1.49-3.89 3.78-3.89 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.77l-.44 2.89h-2.33V22c4.78-.76 8.44-4.89 8.44-9.93z"/>
              </svg>
            </a>
            <a 
              href="https://www.instagram.com/eap_consulting_" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-80 transition"
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="white"
                aria-hidden
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
              </svg>
            </a>
          </div>

          <div className="space-y-3">
            <p className="flex items-center gap-3">
              <span>✉️</span> 
              <a href="mailto:contacto@eapconsulting.mx" className="hover:underline">
                contacto@eapconsulting.mx
              </a>
            </p>
          </div>
        </div>
        <div className="text-sm space-y-2 tracking-wide">
          <Link to="/conozcanos" className="block hover:underline">CONÓZCANOS</Link>
          <Link to="/servicio" className="block hover:underline">SERVICIO</Link>
          <Link to="/nom35" className="block hover:underline">NOM-035</Link>
          <Link to="/conexion-siete" className="block hover:underline">CONEXIÓN SIETE</Link>
          <Link to="/contacto" className="block hover:underline">CONTACTO</Link>
          <Link to="/politica-privacidad" className="block hover:underline">POLÍTICA DE PRIVACIDAD</Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-10">
        <div className="border-t border-white w-full opacity-60 mb-4"></div>
        <p className="text-center text-xs tracking-[0.25em] opacity-90">
          <Link to="/politica-privacidad" className="hover:underline">Políticas de Privacidad</Link>
          {" | "}
          2025 DERECHOS RESERVADOS
        </p>
      </div>
    </footer>
  );
}
